//Operator names
const addOperatorName = "add"
const groupOperator = "group"

//function names
const functionAbs = "abs"
const functionRound = "round"

const functionList = [
  {
    name: "sum",
    display: "Sum()",
    tooltip: "Add a set of numbers together",
    example: "Sum(10, 20, 30) = 60",
  },
  {
    name: functionAbs,
    display: "Abs()",
    tooltip: "Returns the absolute (positive) value of a number.",
    example: "Abs(-100) = 100",
  },
  {
    name: "log",
    display: "Log()",
    tooltip: "Returns the natural logarithm of a number.",
    example: "Log(2) = 0.69",
  },
  {
    name: "max",
    display: "Max()",
    tooltip: "Returns the highest value from a set of numbers.",
    example: "Max(4, 8, 2) = 8",
  },
  {
    name: "min",
    display: "Min()",
    tooltip: "Returns the lowest value from a set of numbers.",
    example: "Min(1, 2, 5) = 1",
  },
  {
    name: functionRound,
    display: "Round()",
    tooltip: "Rounds a number to the nearest integer.",
    example: "Round(2.5) = 3",
  },
  {
    name: "avg",
    display: "Avg()",
    tooltip: "Returns the average of supplied numbers.",
    example: "avg(0, 2, 4) = 2",
  },
  {
    name: "avgNoZero",
    display: "AvgNoZero()",
    tooltip:
      "Returns the average of supplied numbers while excluding zeroes and empty fields.",
    example: "avgNoZero(0, 2, 4) = 3",
  },
  {
    name: "count",
    display: "Count()",
    tooltip:
      "Returns the number of selected options in a Multiple Choice or Single Choice element.",
    example: "Count(0, 2, 4) = 3",
  },
  {
    name: "nth",
    display: "Nth()",
    tooltip: "Returns the nth largest value from a set of numbers.",
    example: "nth(2, 20, 30, 40) = 30",
  },
  {
    name: "addDays",
    display: "AddDays()",
    tooltip: "Adds days to a Date ",
    example: "AddDays(03/23/2024, 2) = 03/25/2024",
  },
  {
    name: "subtractDays",
    display: "SubtractDays()",
    tooltip: "Subtracts days from a Date",
    example: "SubtractDays(03/23/2024, 2) = 03/21/2024",
  },
  {
    name: "minutes",
    display: "Minutes()",
    tooltip: "Converts minutes to milliseconds.",
    example: "minutes(1) = 60,000",
  },
  {
    name: "hours",
    display: "Hours()",
    tooltip: "Converts hours to milliseconds.",
    example: "hours(1) = 3,600,000",
  },
  {
    name: "days",
    display: "Days()",
    tooltip: "Converts days to milliseconds.",
    example: "days(1) = 86,400,000",
  },
  {
    name: "weeks",
    display: "Weeks()",
    tooltip: "Converts weeks to milliseconds.",
    example: "weeks(1) = 604,800,000",
  },
  {
    name: "months",
    display: "Months()",
    tooltip: "Converts months to milliseconds.",
    example: "months(1) = 2,592,000,000",
  },
  {
    name: "dateDiffMinutes",
    display: "DateDiffMinutes()",
    tooltip:
      "Calculates the difference between 2 dates and returns the number of total minutes difference",
    example: "",
  },
  {
    name: "dateDiffHours",
    display: "DateDiffHours()",
    tooltip:
      "Calculates the difference between 2 dates and returns the number of total hours difference",
    example: "",
  },
  {
    name: "dateDiffDays",
    display: "DateDiffDays()",
    tooltip:
      "Calculates the difference between 2 dates and returns the number of total days difference",
    example: "",
  },
  {
    name: "dateDiffWeeks",
    display: "DateDiffWeeks()",
    tooltip:
      "Calculates the difference between 2 dates and returns the number of total weeks difference",
    example: "",
  },
  {
    name: "dateDiffMonths",
    display: "DateDiffMonths()",
    tooltip:
      "Calculates the difference between 2 dates and returns the number of total months difference",
    example: "",
  },
]

const formulaBuilderTypes = {
  formulaTypes: {
    question: "question",
    group: groupOperator,
    number: "number",
    option: "option",
  },
  draggableTypes: {
    operator: "operator",
    number: "number",
    question: "question",
    function: "function",
    group: groupOperator,
    formulaQuestion: "formulaQuestion",
    option: "option",
  },
  droppableIds: {
    connector: "connector_",
  },
  operatorNames: {
    addOperator: addOperatorName,
    groupOperator: groupOperator,
  },
  operators: [
    {
      name: addOperatorName,
      display: "+",
      iconName: "add",
      tooltip: "Add values",
    },
    {
      name: "subtract",
      display: "-",
      iconName: "remove",
      tooltip: "Subtract values",
    },
    {
      name: "multiply",
      display: "X",
      iconName: "close",
      tooltip: "Multiply values",
    },
    { name: "divide", display: "/", tooltip: "Divide values" },
    {
      name: groupOperator,
      display: "( )",
      isPurple: true,
      tooltip: "Group calculations",
    },
  ],
  functionNames: {
    abs: functionAbs,
    round: functionRound,
  },
  functions: functionList,
  getFunction: (name) => {
    return functionList.find((func) => func.name === name)
  },
}

export default formulaBuilderTypes
